import UserResource from '@/resources/UserResource.js'
import LoginUtils from "@/util/LoginUtils"

const state = () => ({
  user: null,
  provedor: null,
  authorities: null,
  jwt: LoginUtils.getJWT()
})

const getters = {
	user: (state) => state.user,
	jwt: (state) => state.jwt,
	authorities: (state) => state.authorities
}

const mutations = {
  clearUserInfo(state) {
		state.user = null
		state.authorities = null
	},
	setUserInfo(state, {user, authorities}) {
      state.user = user
      state.authorities = authorities
  },
	saveOuthTokens(state, {accessToken, refreshToken, changedUser}) {
		LoginUtils.saveOuthTokens({accessToken, refreshToken, changedUser});
		mutations.clearUserInfo(state);
		state.jwt = LoginUtils.getJWT();

	},
	clearLoggedUser(state) {
		LoginUtils.clearTokens();
		mutations.clearUserInfo(state);
		state.jwt = null;
	},
};

const actions = {
  async loadUserInfo({ commit }) {
    UserResource.info({showLoader: true})
    .then(userInfo => {
          commit('setUserInfo', userInfo)
    })
  },
  async saveOuthTokens({ commit }, tokensResponse) {
    commit('saveOuthTokens', tokensResponse)
  },
  async clearLoggedUser({ commit }) {
    commit('clearLoggedUser')
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}